import type { CompetitorCreativeCardModel } from "./drilldown-card.types"

const KEEP_DRAWER_OPEN_SELECTORS = [
  "[data-drilldown-scroll]",
  "[data-top-nav]",
  "[role='menu']",
  "[data-radix-popper-content-wrapper]",
]

// The close × sits on the media column's blurred backdrop; without its own surface it drops to
// ~1.4:1 in dark mode, under the 3:1 minimum for controls.
export const DRILLDOWN_DRAWER_CLOSE_CLASS = "border border-border bg-card text-foreground shadow-sm"

export function shouldKeepDrilldownDrawerOpenOnOutsideInteraction(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  return KEEP_DRAWER_OPEN_SELECTORS.some((selector) => target.closest(selector) !== null)
}

/** Included carousel assets (slides 1+) have no CreativeHashData — skip fetch and show empty values. */
export function isIncludedCarouselSlide(
  creative: CompetitorCreativeCardModel | null,
  slideIndex: number,
): boolean {
  return Boolean(creative?.isCarousel && slideIndex > 0)
}
